import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {PatientService} from '../../../services/patient/patient.service';
import {RecipeService} from '../../../services/recipe/recipe.service';
import {PatientModel} from '../../../models/patient/patient.model';
import {ReservedAppointmentsModel} from '../../../models/appointment/appointment.model';
import {RecipeModel} from '../../../models/recipe/recipe.model';
import {iResponse, iResponseList} from '../../../models/response/response.model';
import {DatePipe} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-patient-dashboard',
  standalone: true,
  imports: [
    DatePipe,
    RouterLink
  ],
  templateUrl: './patient-dashboard.component.html',
  styleUrl: './patient-dashboard.component.sass'
})
export class PatientDashboardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  patient: PatientModel | null = null;
  nextAppointment: ReservedAppointmentsModel | null = null;
  latestRecipe: RecipeModel | null = null;
  isLoading = true;

  constructor(
    private patientService: PatientService,
    private recipeService: RecipeService
  ) {}

  ngOnInit(): void {
    this.loadDashboardData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadDashboardData(): void {
    this.patientService.getMe()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: iResponse<PatientModel>) => {
          this.patient = response.data;
          this.loadNextAppointment();
          this.loadLatestRecipe();
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  private loadNextAppointment(): void {
    if (!this.patient) return;

    const query = {
      from: new Date().toISOString(),
      limit: 1,
      sort: 'from',
      order: 'asc'
    };

    this.patientService.getPatientAppointments(this.patient.id, query)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: iResponseList<ReservedAppointmentsModel>) => {
          if (response.data && response.data.length > 0) {
            this.nextAppointment = response.data[0];
          }
        }
      });
  }

  private loadLatestRecipe(): void {
    const query = {
      limit: 1,
      sort: 'createdAt',
      order: 'desc'
    };

    this.recipeService.getRecipes(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: iResponseList<RecipeModel>) => {
          if (response.data && response.data.length > 0) {
            this.latestRecipe = response.data[0];
          }
        }
      });
  }
}
